export default {
  paymentMethod: {
    OFFLINE: { text: "Externo", color: "grey" },
    MERCADOPAGO: { text: "Mercado Pago", color: "blue" },
    COURTESY: { text: "Cortesia", color: "green" },
    PAGSEGURO: { text: "PagSeguro", color: "#ffe72d" },
    CIELO: { text: "Cielo", color: "#08b0f0" },
    PAGARME: { text: "Pagar.me", color: "#00af55" },
    POS: { text: "POS", color: "danger" },
    INTER: { text: "Banco Inter", color: "#f27321" },
    UNDEFINED: { text: "Não definido", color: "grey" },
  },
  paymentType: {
    UNKNOWN: { text: "Desconhecido", short: "Desconhecido", color: "#333" },
    DEBIT_CARD: { text: "Cartão de Débito", short: "Débito", color: "#fff800" },
    CREDIT_CARD: { text: "Cartão de Crédito", short: "Crédito", color: "#7c65ff" },
    PIX: { text: "Pix", short: "Pix", color: "#00bdae" },
    PAYPAL: { text: "PayPal", short: "PayPal", color: "#273469" },
    BANK_TRANSFER: { text: "Transferência Bancária", short: "Transferência", color: "#ff5b5b" },
    COURTESY: { text: "Cortesia", short: "Cortesia", color: "#fe6fff" },
    MONEY: { text: "Dinheiro", short: "Dinheiro", color: "#4caf50" },
    QR_CODE: { text: "QR Code", short: "QR Code", color: "#ff5b5b" },
  },
  ticketStatus: {
    succeeded: { text: "Aprovado", color: "success", icon: "mdi-check" },
    canceled: { text: "Cancelado", color: "grey", icon: "mdi-close" },
    refunded: { text: "Reembolsado", color: "info", icon: "mdi-credit-card-refund" },
    disputed: { text: "Disputa", color: "error", icon: "mdi-alert" },
    rejected: { text: "Rejeitado", color: "error", icon: "mdi-credit-card-remove" },
    pending: { text: "Pendente", color: "warning", icon: "mdi-credit-card-clock" },
    requires_payment_method: { text: "Aguardando Pagamento", color: "warning", icon: "mdi-alert" },
    requires_confirmation: { text: "Aguardando Confirmação", color: "warning", icon: "mdi-credit-card-sync" },
    requires_action: { text: "Aguardando Ação", color: "warning", icon: "mdi-credit-card-sync" },
    processing: { text: "Processando", color: "warning", icon: "mdi-credit-card-clock" },
    requires_capture: { text: "Aprovado (Não Capturado)", color: "success", icon: "mdi-check" },
  },

  status_db_groups: {
    approved: ["succeeded"],
    canceled: ["canceled", "refunded", "disputed"],
    pending: [
      "pending",
      "requires_payment_method",
      "requires_confirmation",
      "requires_action",
      "processing",
      "requires_capture",
      "rejected",
    ],
    pending_action: ["requires_action"],
  }
};
